"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const store_1 = __importDefault(require("../store"));
const userTyping_1 = require("../actions/chats/userTyping");
const MARK_TYPING_STOPPED_INTERVAL_MS = 5000; // 5 seconds
class RemoteUserTypingHandler {
    constructor() {
        this.userStoppedTypingTimeoutIds = new Map();
        this.markTyping = (chatId, userId) => {
            const event = {
                type: userTyping_1.REMOTE_USER_TYPING,
                payload: {
                    chatId,
                    userId
                }
            };
            store_1.default.dispatch(event);
            const key = this.buildTimeoutKey(chatId, userId);
            const existingTimeoutId = this.userStoppedTypingTimeoutIds.get(key);
            if (existingTimeoutId) {
                clearTimeout(existingTimeoutId);
            }
            const newTimeoutId = setTimeout(() => this.markTypingStopped(chatId, userId), MARK_TYPING_STOPPED_INTERVAL_MS);
            this.userStoppedTypingTimeoutIds.set(key, newTimeoutId);
        };
        this.markTypingStopped = (chatId, userId) => {
            const key = this.buildTimeoutKey(chatId, userId);
            const timeoutId = this.userStoppedTypingTimeoutIds.get(key);
            if (timeoutId) {
                this.userStoppedTypingTimeoutIds.delete(key);
                clearTimeout(timeoutId);
                const event = {
                    type: userTyping_1.REMOTE_USER_STOPPED_TYPING,
                    payload: {
                        chatId,
                        userId
                    }
                };
                store_1.default.dispatch(event);
            }
        };
        this.buildTimeoutKey = (chatId, userId) => `${chatId}-${userId}`;
    }
}
const handler = new RemoteUserTypingHandler();
exports.default = handler;
